/* Bactera · vaginal collection page
   Three behaviours on top of plain HTML:
   1. the quantity steppers next to the add-to-cart buttons
   2. the "On this page" rail: reveal it once the hero has scrolled away,
      and mark the section you are currently reading
   3. smooth scrolling for the rail's own links
   The FAQ accordions are native <details>, so there is nothing to do there.
   What still watches the scroll position shares one frame (frame, below,
   also window.vcScroll for other scripts); the product page's rail uses
   intersection observers instead and measures nothing while scrolling. */
(function () {
  'use strict';

  /* vc-head renders once per VC section, so a page carries as many copies of
     this tag as it has sections. The browser fetches the file once and runs
     it once per tag; everything below sets up listeners, so it must happen
     exactly once. */
  if (window.__vcLoaded) return;
  window.__vcLoaded = true;

  /* ------------------------------------------------------ scroll frame --
     Everything that watches the scroll position shares one frame. On a
     scroll or resize, one animation frame runs every registered read (the
     measurements) and only then every write (the class and style changes),
     so the page is laid out once per frame however many watchers there
     are. Before, each watcher measured and wrote in a frame callback of its
     own, and every one of them paid for a fresh layout of the whole page
     after the previous one's writes: four or five layouts per scrolled
     frame on a page of 6,000 elements (PageSpeed, October 2026). The sub
     nav of the landing and collection pages and the corporate page's nav
     use it; another script can join through window.vcScroll.

     add(read, write): read() returns a state, write(state) applies it;
     both optional. schedule(): run a frame soon. rerun(): and one more
     after it, for a write that changes what the next read will see. */
  var frame = (function () {
    var items = [], queued = false, again = false;
    function run() {
      queued = false;
      var states = [];
      for (var i = 0; i < items.length; i++) states[i] = items[i].read ? items[i].read() : undefined;
      for (var j = 0; j < items.length; j++) if (items[j].write) items[j].write(states[j]);
      if (again) { again = false; schedule(); }
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(run);
    }
    function add(read, write) {
      items.push({ read: read, write: write });
      schedule();
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);
    return { add: add, schedule: schedule, rerun: function () { again = true; schedule(); } };
  })();
  window.vcScroll = frame;

  /* ---------------------------------------------------------- quantity -- */
  function clamp(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 999) n = 999;
    return n;
  }

  function bindQty(root) {
    var boxes = (root || document).querySelectorAll('[data-vc-qty]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.vcQtyBound === '1') return;
      box.dataset.vcQtyBound = '1';
      var input = box.querySelector('.qty-num');
      if (!input) return;
      box.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-vc-step]');
        if (!btn || !box.contains(btn)) return;
        e.preventDefault();
        input.value = clamp(clamp(input.value) + parseInt(btn.getAttribute('data-vc-step'), 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('change', function () { input.value = clamp(input.value); });
      input.addEventListener('blur', function () { input.value = clamp(input.value); });
    });
  }

  /* -------------------------------------------------------------- rail -- */
  function num(v, dflt) {
    var n = parseFloat(v);
    return isNaN(n) ? dflt : n;
  }

  function bindNav() {
    var nav = document.querySelector('.vc .subnav');
    if (!nav || nav.dataset.vcNavBound === '1') return;
    nav.dataset.vcNavBound = '1';

    var root = document.documentElement;

    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var hero = document.querySelector('.vc header.hero');

    /* The rail is fixed, so it would otherwise ride over the footer at the
       bottom of the page. The footer is the theme's, not ours, so look for it
       the way a theme normally marks it and settle for the first match. */
    var footer = document.querySelector(
      'footer, .shopify-section-group-footer-group, [id*="sections--"][id*="footer"], #shopify-section-footer');
    var targets = links.map(function (a) {
      try { return document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))); }
      catch (e) { return null; }
    });

    /* the rail is position:fixed, so its own top is the offset everything
       else is measured against - no constant to keep in sync with the CSS */
    function railTop() {
      var t = nav.getBoundingClientRect().top;
      return isNaN(t) ? 134 : t;
    }

    /* Withdraw the rail whenever it would touch the page content, or squeeze
       that content too narrow. Everything is measured with the "rail on"
       layout forced back on first, so the answer never depends on the answer
       we gave last time - otherwise hiding the rail would widen the content,
       which would say the rail fits, which would hide it again. */
    function fitRail() {
      var minWidth   = num(nav.getAttribute('data-vc-min-width'), 1400);
      var minGap     = num(nav.getAttribute('data-vc-min-gap'), 32);
      var minContent = num(nav.getAttribute('data-vc-min-content'), 860);

      if (root.clientWidth < minWidth) { root.classList.add('vc-rail-off'); return; }

      var wasOff = root.classList.contains('vc-rail-off');
      if (wasOff) root.classList.remove('vc-rail-off');

      /* offsetLeft/offsetWidth rather than a rect: the rail carries a
         translate while it is still hidden, and that must not count. */
      var railRight = nav.offsetLeft + nav.offsetWidth;
      var fits = nav.offsetWidth > 0 && nav.offsetLeft >= 8;

      if (fits) {
        var shells = document.querySelectorAll('.vc .shell');
        for (var i = 0; i < shells.length; i++) {
          var el = shells[i];
          var r = el.getBoundingClientRect();
          if (r.width <= 0) continue;                 /* a section that is not shown */
          var cs = window.getComputedStyle(el);
          var padL = num(cs.paddingLeft, 0);
          var padR = num(cs.paddingRight, 0);
          if (r.left + padL - railRight < minGap) { fits = false; break; }
          if (r.width - padL - padR < minContent) { fits = false; break; }
        }
      }

      root.classList.toggle('vc-rail-off', !fits);
    }

    /* true while the rail still has clear space above the footer */
    function clearOfFooter() {
      if (!footer) return true;
      var gap = num(nav.getAttribute('data-vc-footer-gap'), 24);
      var top = footer.getBoundingClientRect().top;
      if (isNaN(top)) return true;
      return nav.offsetTop + nav.offsetHeight + gap <= top;
    }

    /* reveal past the hero and spy the current section: measured and
       written in the page's shared frame (see frame above) */
    function measureNav() {
      var top = railTop();
      var pastHero = true;
      if (hero) pastHero = hero.getBoundingClientRect().bottom < top - 44;
      var mark = window.scrollY + top + 36, current = -1;
      for (var i = 0; i < targets.length; i++) {
        var t = targets[i];
        if (!t) continue;
        if (t.getBoundingClientRect().top + window.scrollY <= mark) current = i;
      }
      return { visible: pastHero && clearOfFooter(), current: current };
    }
    function paintNav(st) {
      nav.classList.toggle('visible', st.visible);
      for (var j = 0; j < links.length; j++) {
        links[j].classList.toggle('active', j === st.current);
      }
    }
    frame.add(measureNav, paintNav);

    /* widths only change on resize, so the (reflowing) fit test stays off
       the scroll path; it writes and measures in turn, so it runs on its
       own and the shared frame follows it */
    var sizing = false;
    function onResize() {
      if (sizing) return;
      sizing = true;
      requestAnimationFrame(function () { fitRail(); sizing = false; frame.schedule(); });
    }
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('load', onResize);
    onResize();

    /* the design relies on smooth scrolling, which is scoped out of the
       stylesheet so it cannot affect the rest of the theme */
    var smooth = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || !smooth) return;
      var el = targets[links.indexOf(a)];
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    });
  }

  /* ------------------------------------------------------------------
     Age tiers.

     Two things share one piece of state - which tier the visitor has
     chosen: the tab bar that reveals a tier's panel, and the age select
     inside each buy form. Picking a tab preselects the tier in the buy
     forms; picking it in one buy form moves the other and opens the
     matching panel.

     The tab bar and the panels are separate Shopify sections, so nothing
     here may assume they are siblings; everything is paired on
     data-vc-tier, which the template keeps in step.

     The selects carry "required" with nothing preselected, so the browser
     already refuses to submit without a tier. This only adds the softer
     prompt on top, and so it is safe for it never to run.
     ------------------------------------------------------------------ */
  function bindTiers() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.tierbtn[data-vc-tier]'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('.tierpanel[data-vc-tier]'));
    var selects = Array.prototype.slice.call(document.querySelectorAll('select[data-agepick]'));
    if (!tabs.length && !selects.length) return;

    function idxOf(el) { return parseInt(el.getAttribute('data-vc-tier'), 10) || 0; }

    function showTier(i) {
      tabs.forEach(function (t) {
        var on = idxOf(t) === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) { p.classList.toggle('on', idxOf(p) === i); });
    }

    /* A tab and an option are paired by the variant title the template put on
       the tab; failing that, by position, so a half-filled section still works. */
    function optionFor(sel, tab) {
      var want = tab.getAttribute('data-vc-variant');
      var opts = Array.prototype.slice.call(sel.options).filter(function (o) { return o.value !== ''; });
      if (want) {
        for (var i = 0; i < opts.length; i++) {
          if ((opts[i].getAttribute('data-vc-title') || opts[i].text).trim() === want.trim()) return opts[i];
        }
      }
      return opts[idxOf(tab)] || null;
    }

    function tabForValue(v) {
      for (var i = 0; i < tabs.length; i++) {
        var o = null, sel = selects[0];
        if (sel) o = optionFor(sel, tabs[i]);
        if (o && o.value === v) return tabs[i];
      }
      return null;
    }

    function chosen() { return selects.length ? selects[0].value !== '' : true; }

    function paint() {
      var ok = chosen();
      var label = '';
      if (ok && selects[0].selectedIndex >= 0) {
        var o = selects[0].options[selects[0].selectedIndex];
        label = (o.getAttribute('data-vc-title') || o.text || '').trim();
      }
      selects.forEach(function (sel) {
        sel.classList.toggle('needs', !ok);
        var form = sel.form;
        var btn = form && form.querySelector('button[type="submit"], .btn');
        if (btn) {
          btn.classList.toggle('is-off', !ok);
          btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
        }
        var hint = sel.parentNode.querySelector('.hint');
        if (!hint) return;
        hint.classList.remove('warn');
        var d = hint.getAttribute('data-vc-hint-default') || '';
        var done = hint.getAttribute('data-vc-hint-chosen') || '';
        hint.textContent = (ok && done) ? done.replace('[tier]', label) : d;
      });
    }

    function setValue(v, from) {
      selects.forEach(function (sel) { if (sel !== from) sel.value = v; });
      var t = tabForValue(v);
      if (t) showTier(idxOf(t));
      paint();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        showTier(idxOf(tab));
        if (!selects.length) return;
        var o = optionFor(selects[0], tab);
        if (o && selects[0].value !== o.value) { selects.forEach(function (s) { s.value = o.value; }); paint(); }
      });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab), n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n === null) return;
        e.preventDefault();
        tabs[n].focus();
        tabs[n].click();
      });
    });

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () { setValue(sel.value, sel); });
      var form = sel.form;
      if (!form) return;
      form.addEventListener('submit', function (e) {
        if (chosen()) return;
        e.preventDefault();
        selects.forEach(function (s) {
          s.classList.add('needs');
          var h = s.parentNode.querySelector('.hint');
          var w = h && h.getAttribute('data-vc-hint-warn');
          if (h && w) { h.classList.add('warn'); h.textContent = w; }
        });
        sel.focus();
        if (sel.scrollIntoView) sel.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    });

    if (tabs.length) showTier(idxOf(tabs[0]));
    paint();
  }

  /* ------------------------------------------------------------------
     Product page behaviours. Each one finds its own markup and does nothing
     on a page without it, so this is safe to run everywhere.
     ------------------------------------------------------------------ */

  /* Reveal on scroll: .rv sits at opacity 0 until it is in view. Without an
     observer, or with reduced motion, everything is shown at once. */
  function bindReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.vc .rv:not(.in)'));
    if (!els.length) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        // Also reveal anything the viewport has already passed: a jump to an
        // anchor, or a fast flick, can carry a block from below the fold to
        // above it between two frames, and the observer then never sees it
        // intersect. Without this, that block stays at opacity 0 for good.
        if (x.isIntersecting || x.boundingClientRect.top < window.innerHeight) {
          x.target.classList.add('in');
          io.unobserve(x.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* The sequencing-depth figure counts up from zero when it scrolls into
     view. The final text is whatever the merchant typed, so the count only
     borrows the element and hands the wording back at the end. */
  function bindCounter() {
    var cnt = document.querySelector('.vc .depth-bars b[data-count]');
    if (!cnt || cnt.getAttribute('data-vc-counted')) return;
    cnt.setAttribute('data-vc-counted', '1');
    var target = parseInt(cnt.getAttribute('data-count'), 10);
    var finalText = cnt.textContent;
    if (!target || !('IntersectionObserver' in window)) return;
    var unit = (finalText.match(/[^\d.,\s]+.*$/) || [''])[0].trim();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (!x.isIntersecting) return;
        io.unobserve(cnt);
        var start = performance.now();
        (function frame(now) {
          var p = Math.min(1, (now - start) / 1400), e = 1 - Math.pow(1 - p, 3);
          var v = Math.round(target * e);
          cnt.textContent = (v / 1e6).toLocaleString(document.documentElement.lang || 'en', { maximumFractionDigits: 1 }) + (unit ? ' ' + unit : '');
          if (p < 1) requestAnimationFrame(frame); else cnt.textContent = finalText;
        })(start);
      });
    }, { threshold: 0.5 });
    io.observe(cnt);
  }

  /* Gallery: a thumbnail swaps the main picture. */
  function bindGallery() {
    document.querySelectorAll('.vc .gal').forEach(function (gal) {
      if (gal.getAttribute('data-vc-bound')) return;
      gal.setAttribute('data-vc-bound', '1');
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.thumbs button[data-vc-image]'));
      var main = gal.querySelector('.main img');
      if (!thumbs.length || !main) return;
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          gal.querySelectorAll('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          b.setAttribute('aria-current', 'true');
          main.removeAttribute('srcset');
          main.src = b.getAttribute('data-vc-image');
          var stage = gal.querySelector('.main');
          var fit = b.getAttribute('data-vc-fit');
          if (stage && fit) stage.setAttribute('data-fit', fit);
          var img = b.querySelector('img');
          if (img && img.alt) main.alt = img.alt;
        });
      });
    });
  }

  /* The analysis explorer: tabs on wide screens, an accordion on narrow ones. */
  function bindExplorer() {
    document.querySelectorAll('.vc .xp').forEach(function (xp) {
      if (xp.getAttribute('data-vc-bound')) return;
      xp.setAttribute('data-vc-bound', '1');
      var tabs = Array.prototype.slice.call(xp.querySelectorAll('.xp-tab'));
      var panes = Array.prototype.slice.call(xp.querySelectorAll('.xp-pane'));
      if (!tabs.length) return;
      function show(i) {
        tabs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panes.forEach(function (p, j) { p.classList.toggle('is-on', j === i); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (n === null) return;
          e.preventDefault(); tabs[n].focus(); show(n);
        });
      });
      panes.forEach(function (p, i) {
        var h = p.querySelector('.xp-ph');
        if (!h) return;
        if (i === 0) p.classList.add('is-open');
        h.addEventListener('click', function () {
          var open = !p.classList.contains('is-open');
          p.classList.toggle('is-open', open);
          h.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* "Show N more" under the buy-box checklist. */
  function bindChecklist() {
    document.querySelectorAll('.vc .pbul-wrap').forEach(function (w) {
      if (w.getAttribute('data-vc-bound')) return;
      w.setAttribute('data-vc-bound', '1');
      var btn = w.querySelector('.pbul-btn'), more = w.querySelector('.pbul-more');
      if (!btn || !more) return;
      btn.addEventListener('click', function () {
        var open = !w.classList.contains('is-open');
        w.classList.toggle('is-open', open);
        more.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Functional panels: on a phone a card folds to its header. */
  function bindDrivers() {
    document.querySelectorAll('.vc .fpx-h').forEach(function (h) {
      if (h.getAttribute('data-vc-bound')) return;
      h.setAttribute('data-vc-bound', '1');
      h.addEventListener('click', function () {
        if (window.innerWidth > 860) return;
        var b = h.parentElement.querySelector('.fpx-body');
        if (!b) return;
        var open = !b.classList.contains('is-open');
        b.classList.toggle('is-open', open);
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* "In detail": a plain tab row. */
  function bindDetailTabs() {
    document.querySelectorAll('.vc .dpanel').forEach(function (panel) {
      if (panel.getAttribute('data-vc-bound')) return;
      panel.setAttribute('data-vc-bound', '1');
      var tabs = Array.prototype.slice.call(panel.querySelectorAll('.dtab'));
      var panes = Array.prototype.slice.call(panel.querySelectorAll('.dpane'));
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, j) { x.classList.toggle('is-on', j === i); x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
          panes.forEach(function (p, j) { p.classList.toggle('is-on', j === i); });
        });
      });
    });
  }

  /* Functional panels and the risk list are the same accordion: a row that
     opens its own item. The row is a div with role="button", so Enter and
     Space have to be handled as well as the click. */
  function bindRows() {
    [['.vc .fpo-item', '.fpo-row'], ['.vc .rk-item', '.rk-row']].forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (it) {
        var row = it.querySelector(pair[1]);
        if (!row || row.getAttribute('data-vc-bound')) return;
        row.setAttribute('data-vc-bound', '1');
        function toggle() {
          var open = !it.classList.contains('is-open');
          it.classList.toggle('is-open', open);
          row.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        row.addEventListener('click', toggle);
        row.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      });
    });
  }

  /* The microbial profile: seven group strips over a tabbed detail pane.
     Every dot, pane and label is rendered by the section, so this only moves
     the selection around and never rebuilds any markup. */
  function bindMprofile() {
    document.querySelectorAll('.vc .mp-wrap[data-vc-mprofile]').forEach(function (w) {
      if (w.getAttribute('data-vc-bound')) return;
      w.setAttribute('data-vc-bound', '1');
      var tabs = Array.prototype.slice.call(w.querySelectorAll('.mp-tab'));
      var panes = Array.prototype.slice.call(w.querySelectorAll('.mp-pane'));
      function show(i) {
        tabs.forEach(function (t, j) {
          t.classList.toggle('is-on', j === i);
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        });
        panes.forEach(function (p, j) { p.hidden = j !== i; p.classList.toggle('is-on', j === i); });
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

      var rows = w.querySelector('.mp-rows');
      if (!rows) return;
      rows.addEventListener('click', function (e) {
        var d = e.target.closest ? e.target.closest('.mp-dot') : null;
        if (!d || !rows.contains(d)) return;
        var g = d.getAttribute('data-g');
        var row = d.closest('.mp-row');
        var name = row ? row.querySelector('.mp-name') : null;
        // The line is markup the section composed and escaped for the
        // attribute: its only tags are the section's own <em> and the
        // separators, and the organism name inside it was escaped there.
        if (name) name.innerHTML = d.getAttribute('data-mp-name') || '';
        rows.querySelectorAll('.mp-dot.is-sel').forEach(function (x) { x.classList.remove('is-sel'); });
        d.classList.add('is-sel');
        var i = tabs.findIndex(function (t) { return t.getAttribute('data-g') === g; });
        if (i >= 0) show(i);
      });
    });
  }

  /* The vertical section rail: shown once the buy area has scrolled away,
     hidden at the footer, the current section's dot lit, and the whole rail
     opened into a list on very wide screens. */
  function bindVrail() {
    var rail = document.querySelector('.vc .vrail[data-vc-vrail]');
    if (!rail || rail.getAttribute('data-vc-bound')) return;
    rail.setAttribute('data-vc-bound', '1');
    var links = Array.prototype.slice.call(rail.querySelectorAll('a[data-sec]'));
    var afterId = rail.getAttribute('data-vc-after');
    var hero = afterId ? document.getElementById(afterId) : null;
    if (!hero) hero = document.querySelector('.vc-sec--pdp');
    var footer = document.querySelector('footer, .shopify-section-group-footer-group, #shopify-section-footer');
    var openFrom = num(rail.getAttribute('data-vc-open-from'), 1600);
    var footGap = num(rail.getAttribute('data-vc-footer-gap'), 40);
    var topLink = rail.querySelector('a[data-top]');
    if (topLink) topLink.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    var secs = links.map(function (l) { return document.getElementById(l.getAttribute('data-sec')); });
    /* Nothing here is measured while the page scrolls: three intersection
       observers report when the buy area has gone, when the footer comes,
       and which section is under the line 38% down the screen (a band one
       percent tall at that height), and the rail is only ever written from
       their reports. Before, every scrolled frame measured the buy area,
       the footer and every section, and paid for a layout of the whole
       page each time (PageSpeed, October 2026). Below the hiding width the
       stylesheet hides the rail (vc-vrail.js marks it is-off), so there
       the observers stay off as well. */
    var hideBelow = num(rail.getAttribute('data-vc-hide-below'), 1240);
    var st = { narrow: true, wide: false, pastHero: !hero, clear: !footer, cur: -1 };
    function paint() {
      rail.classList.toggle('is-open', st.wide);
      rail.classList.toggle('is-vis', !st.narrow && st.pastHero && st.clear);
      if (st.narrow) return;
      links.forEach(function (l, i) { l.classList.toggle('is-on', i === st.cur); });
    }
    var watching = false;
    function watch() {
      if (watching || !('IntersectionObserver' in window)) return;
      watching = true;
      /* the buy area: gone once its bottom edge is less than 120px from the top */
      if (hero) new IntersectionObserver(function (es) {
        st.pastHero = !es[es.length - 1].isIntersecting;
        paint();
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(hero);
      /* the footer: here once its top edge is within the gap of the bottom */
      if (footer) new IntersectionObserver(function (es) {
        st.clear = !es[es.length - 1].isIntersecting;
        paint();
      }, { rootMargin: '0px 0px ' + (-footGap) + 'px 0px' }).observe(footer);
      /* the current section: the last one whose top edge is above the
         line. The observer reports every section once at the start and
         then each time one crosses the band, with its position. */
      var above = secs.map(function () { return false; });
      var spy = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var line = e.rootBounds ? e.rootBounds.bottom : window.innerHeight * 0.39;
          above[secs.indexOf(e.target)] = e.boundingClientRect.top <= line;
        });
        var cur = -1;
        for (var i = 0; i < above.length; i++) if (above[i]) cur = i;
        st.cur = cur;
        paint();
      }, { rootMargin: '-38% 0px -61% 0px' });
      secs.forEach(function (sec) { if (sec) spy.observe(sec); });
      /* a jump of more than a section in one frame (an anchor without
         smooth scrolling) can carry sections past the band unreported, so
         once the page has come to rest the positions are read once */
      var rest = 0;
      function settle() {
        clearTimeout(rest);
        rest = setTimeout(function () {
          if (st.narrow) return;
          var line = window.innerHeight * 0.39, cur = -1;
          secs.forEach(function (sec, i) {
            above[i] = !!sec && sec.getBoundingClientRect().top <= line;
            if (above[i]) cur = i;
          });
          st.cur = cur;
          paint();
        }, 160);
      }
      window.addEventListener('scroll', settle, { passive: true });
    }
    /* widths change on a resize only */
    function size() {
      var w = window.innerWidth;
      st.narrow = w < hideBelow;
      st.wide = w >= openFrom;
      if (!st.narrow) watch();
      paint();
    }
    window.addEventListener('resize', size, { passive: true });
    size();
  }

  /* The corporate page's own nav bar: it tightens on scroll, opens a sheet on
     a phone and lights the link whose section is in view. */
  function bindCnav() {
    document.querySelectorAll('.vc .hdr[data-vc-cnav]').forEach(function (hdr) {
      if (hdr.getAttribute('data-vc-bound')) return;
      hdr.setAttribute('data-vc-bound', '1');
      var from = num(hdr.getAttribute('data-vc-stuck-from'), 8);
      var burger = hdr.querySelector('.burger');
      var sheet = hdr.querySelector('.mnav');
      if (burger && sheet) {
        burger.addEventListener('click', function () {
          var open = sheet.classList.toggle('open');
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
          var lbl = burger.getAttribute(open ? 'data-vc-close-label' : 'data-vc-open-label');
          if (lbl) burger.setAttribute('aria-label', lbl);
        });
        sheet.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () {
            sheet.classList.remove('open');
            burger.setAttribute('aria-expanded', 'false');
            var lbl = burger.getAttribute('data-vc-open-label');
            if (lbl) burger.setAttribute('aria-label', lbl);
          });
        });
      }
      var links = Array.prototype.slice.call(hdr.querySelectorAll('.nav a[href^="#"]'));
      var secs = links.map(function (a) {
        try { return document.querySelector(a.getAttribute('href')); } catch (e) { return null; }
      });
      /* measured and written in the page's shared frame (see frame above) */
      function measureCnav() {
        var y = window.scrollY, probe = y + 140, cur = -1;
        secs.forEach(function (sec, i) {
          if (sec && sec.getBoundingClientRect().top + y <= probe) cur = i;
        });
        return { stuck: y > from, cur: cur };
      }
      function paintCnav(st) {
        hdr.classList.toggle('stuck', st.stuck);
        links.forEach(function (a, i) { a.classList.toggle('active', i === st.cur); });
      }
      frame.add(measureCnav, paintCnav);
    });
  }

  /* The report deep dive: a tab strip over four panels, arrow keys included. */
  function bindCdeep() {
    document.querySelectorAll('.vc [data-vc-cdeep]').forEach(function (root) {
      if (root.getAttribute('data-vc-bound')) return;
      root.setAttribute('data-vc-bound', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.tab'));
      var panes = Array.prototype.slice.call(root.querySelectorAll('.panel'));
      function show(i) {
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
          t.tabIndex = j === i ? 0 : -1;
        });
        panes.forEach(function (p, j) { p.classList.toggle('show', j === i); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (n === null) return;
          e.preventDefault(); show(n); tabs[n].focus();
        });
      });
      show(0);
    });
  }

  /* Counting figures. The section writes the target on the element and the
     locale beside it, so the formatting follows the page's language rather
     than this file's. */
  function bindCounters() {
    var els = Array.prototype.slice.call(
      document.querySelectorAll('.vc [data-count]:not([data-vc-counted])'));
    if (!els.length) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run(el) {
      if (el.getAttribute('data-vc-counted')) return;
      el.setAttribute('data-vc-counted', '1');
      var target = parseInt(el.getAttribute('data-count'), 10);
      if (isNaN(target) || reduce) return;
      var loc = el.getAttribute('data-count-locale') ||
                (el.closest('[data-locale]') || {}).getAttribute &&
                el.closest('[data-locale]').getAttribute('data-locale') || undefined;
      var t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / 1100), e = 1 - Math.pow(1 - k, 3);
        var v = Math.round(target * e);
        el.textContent = loc ? v.toLocaleString(loc) : String(v);
        if (k < 1) requestAnimationFrame(step);
      }
      el.textContent = '0';
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (!x.isIntersecting && x.boundingClientRect.top >= window.innerHeight) return;
        run(x.target); io.unobserve(x.target);
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* The corporate price calculator. Every price, bracket and word it needs is
     in the markup: the tiers on the table's own rows, the wordings on the
     calculator as data-t-* templates with {price}, {count}, {discount} and
     {percent} placeholders. Nothing here is translated or priced in code. */
  function bindCalc() {
    document.querySelectorAll('.vc .calc[data-vc-calc]').forEach(function (calc) {
      if (calc.getAttribute('data-vc-bound')) return;
      calc.setAttribute('data-vc-bound', '1');
      var scope = calc.closest('[data-vc-cpricing]') || document;
      var rows = Array.prototype.slice.call(scope.querySelectorAll('.ptable tr[data-tier]'));
      var bars = Array.prototype.slice.call(scope.querySelectorAll('.sv[data-tier]'));
      var tiers = rows.map(function (r) {
        return {
          tier: num(r.getAttribute('data-tier'), 0),
          min: num(r.getAttribute('data-min'), 0),
          max: r.hasAttribute('data-max') ? num(r.getAttribute('data-max'), 0) : Infinity,
          price: parseFloat(r.getAttribute('data-price')),
          disc: r.getAttribute('data-disc') || ''
        };
      }).filter(function (t) { return !isNaN(t.price) && t.min > 0; });
      if (!tiers.length) return;

      var regular = parseFloat(calc.getAttribute('data-regular'));
      if (isNaN(regular)) regular = tiers[0].price;
      var loc = calc.getAttribute('data-locale') || undefined;
      var cur = calc.getAttribute('data-currency') || 'EUR';
      var money;
      try {
        var nf = new Intl.NumberFormat(loc, { style: 'currency', currency: cur, minimumFractionDigits: 2 });
        money = function (v) { return nf.format(v); };
      } catch (e) {
        money = function (v) { return v.toFixed(2); };
      }
      function n(v) { return loc ? v.toLocaleString(loc) : String(v); }
      function tpl(name, vals) {
        var t = calc.getAttribute('data-t-' + name);
        if (!t) return '';
        return t.replace(/\{(price|count|discount|percent)\}/g, function (_, k) {
          return vals[k] === undefined ? '' : vals[k];
        });
      }
      function out(key) { return scope.querySelector('[data-vc-out="' + key + '"]'); }
      function put(key, text) { var el = out(key); if (el) el.textContent = text; }

      var qty = calc.querySelector('input[type="range"][data-vc-out="qty-rng"]') ||
                calc.querySelectorAll('input[type="range"]')[0];
      var share = calc.querySelector('input[type="range"][data-vc-out="sub-rng"]') ||
                  calc.querySelectorAll('input[type="range"]')[1];
      if (!qty) return;
      var chips = Array.prototype.slice.call(calc.querySelectorAll('.qchips button, [id^="vc-qchips"] button'));

      function fill(el) {
        if (!el) return;
        var lo = num(el.min, 0), hi = num(el.max, 100);
        el.style.setProperty('--pos', (hi > lo ? (num(el.value, lo) - lo) / (hi - lo) * 100 : 0) + '%');
      }
      function tierFor(q) {
        for (var i = 0; i < tiers.length; i++) {
          if (q >= tiers[i].min && q <= tiers[i].max) return i;
        }
        return tiers.length - 1;
      }
      function render() {
        var q = num(qty.value, tiers[0].min), i = tierFor(q), t = tiers[i];
        var pct = share ? num(share.value, 100) : 100;
        var total = q * t.price, save = q * (regular - t.price);
        var budget = total * pct / 100, own = t.price * (100 - pct) / 100;

        put('qtyOut', n(q));
        put('oPer', money(t.price));
        put('oDisc', tpl('discount', { discount: t.disc }));
        put('oTotal', money(total));
        put('oQty', tpl('count', { count: n(q) }));
        put('oSave', money(save));
        put('oSaveSub', tpl('per', { price: money(regular - t.price) }));

        var nx = tiers[i + 1];
        put('oNext', nx ? tpl('next', { count: n(nx.min), price: money(nx.price) })
                        : tpl('best', { price: money(t.price) }));

        put('subOut', tpl('share-out', { percent: pct }));
        put('oBudget', money(budget));
        put('oBudgetSub', tpl('per', { price: money(t.price * pct / 100) }));
        put('oOwn', money(own));
        put('oOwnSub', pct === 100 ? (calc.getAttribute('data-t-covered') || '')
                                   : (calc.getAttribute('data-t-own') || ''));

        rows.forEach(function (r) { r.classList.toggle('on', num(r.getAttribute('data-tier'), -1) === t.tier); });
        bars.forEach(function (b) { b.classList.toggle('on', num(b.getAttribute('data-tier'), -1) === t.tier); });
        chips.forEach(function (b) { b.classList.toggle('on', num(b.getAttribute('data-q'), -1) === q); });
        fill(qty); fill(share);
      }
      qty.addEventListener('input', render);
      if (share) share.addEventListener('input', render);
      chips.forEach(function (b) {
        b.addEventListener('click', function () { qty.value = b.getAttribute('data-q'); render(); });
      });
      render();
    });
  }

  function bind(root) {
    bindQty(root); bindNav(); bindTiers();
    bindReveal(); bindCounter(); bindGallery(); bindExplorer(); bindChecklist(); bindDrivers();
    bindDetailTabs(); bindVrail(); bindRows(); bindMprofile();
    bindCnav(); bindCdeep(); bindCounters(); bindCalc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  /* the theme editor re-renders single sections, so re-bind on those events */
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('shopify:section:select', function (e) { bind(e.target); });
})();
